import "react";
import { jsx as o, jsxs as r } from "react/jsx-runtime";
var d = (e) => /* @__PURE__ */ r("svg", {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: [
    /* @__PURE__ */ o("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.3567 34.0233L5.97667 27.6433C5.35167 27.0183 5 26.17 5 25.2867V14.7133C5 13.83 5.35167 12.9817 5.97667 12.3567L12.3567 5.97667C12.9817 5.35167 13.83 5 14.7133 5H25.285C26.1683 5 27.0167 5.35167 27.6417 5.97667L34.0217 12.3567C34.6483 12.9817 35 13.83 35 14.7133V25.285C35 26.1683 34.6483 27.0167 34.0233 27.6417L26.6667 35H14.7133C13.83 35 12.9817 34.6483 12.3567 34.0233V34.0233Z",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      d: "M15 25L25 15",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      d: "M25 25L15 15",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  ]
});
export {
  d as default
};

//# sourceMappingURL=DialogError.js.map